










































































































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchSolicitud } from '../fetchSolicitud';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';

@Component({
  components: {
    MantenedorGrid,
    FormFieldsContainer,
  },
})
export default class TodasSims extends ComponenteBase {
  @Prop({ required: true }) dataSelected: any;
  @Prop({ default: [] }) idsSims: any;
  @Prop({ default: false }) DispositivosTotalesSim: boolean;

  accionesTotales: PermisoAccion[];
  filtro: string = '';
  ordesList: any[] = [];

  funcionalidad: Funcionalidades = Funcionalidades.TablaSolicitudBajaSimTarjeta;
  usuario = JSON.parse(localStorage.getItem('user')).id;

  clearFilters() {
    this.formFields.ubicacion.value = '';
    this.formFields.telco.value = '';
    this.formFields.plan.value = '';
    this.formFields.equipoSerie.value = '';
    this.formFields.simSerie.value = '';
    this.filtroRequerimiento(true);
  }

  async getPlanes() {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitud(
      { telco: this.formFields.telco.value },
      'solicitud_baja_sim_por_tarjeta/get_planes'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          this.loadingService.hideLoading();
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }

  planes: any = [];
  async cargarPlanes() {
    if (this.formFields.telco.value) {
      this.planes = await this.getPlanes();
    }
  }

  cerrarModal() {
    this.$emit('DispositivosTotalesSim', false);
  }

  recargarSelected() {
    this.gridApi.forEachNode(function(node) {
      node.setSelected(false);
    });
  }

  ubicaciones: any = [];
  telcos: any = [];
  async getFiltersTotalSims() {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitud(
      {},
      'solicitud_baja_sim_por_tarjeta/get_filters_total_sims'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ubicaciones = data.data.UBICACIONES;
          this.telcos = data.data.TELCOS;
          this.loadingService.hideLoading();
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error1', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }

  async getFilters() {
    await this.getFiltersTotalSims();
  }

  mounted() {
    this.getFilters();
  }

  Sims: any;
  guardar() {
    this.Sims = this.gridApi.getSelectedRows();
    this.$emit('selected', this.Sims);
    this.$emit('DispositivosTotalesSim', false);
  }

  cant_regs_pag: number = 8;

  handleBuscarClick() {
    this.filtroRequerimiento(true);
    this.recargarSelected();
  }

  filtroRequerimiento(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.gridApi.deselectAll();
  }

  pagina: number = 1;

  gridEvent: any = null;
  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setDomLayout('autoHeight');
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.serverSide = {
      getRows(event: any): void {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        this.pagina = Math.ceil(
          event.request.startRow / this.cant_regs_pag + 1
        );

        fetchSolicitud(
          {
            pagina: event.request.startRow,
            ubicacion: self.formFields.ubicacion.value
              ? self.formFields.ubicacion.value
              : '',
            telco: self.formFields.telco.value
              ? self.formFields.telco.value
              : '',
            plan: self.formFields.plan.value ? self.formFields.plan.value : '',
            serie: self.formFields.equipoSerie.value
              ? self.formFields.equipoSerie.value
              : '',
            simSerie: self.formFields.simSerie.value
              ? self.formFields.simSerie.value
              : '',
            idsSims: self.idsSims,
          },
          'solicitud_baja_sim_por_tarjeta/get_filtered_sims'
        )
          .then((data: any) => {
            if (data.data.CODIGO_RESPUESTA == '1') {
              self.loadingService.hideLoading();
              event.successCallback(
                data.data.data.LISTA,
                Number(data.data.cant_regs_pag.TOTAL_REGISTROS)
              );
            } else {
              self.loadingService.hideLoading();
              self.$snotify.error(data.data.MENSAJE_RESPUESTA, {
                timeout: 3000,
              });
            }
          })
          .catch((error: any) => {
            self.loadingService.hideLoading();
            self.$snotify.error(error, { timeout: 3000 });
          });
      },
    };
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  // Globales
  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;

  loadingService = new LoadingService();

  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('MM/DD/YYYY');
  }

  formFields: FormFieldDefMap = {
    ubicacion: {
      label: 'Ubicación',
      value: '',
      id: '',
    },
    telco: {
      label: 'Telco',
      value: '',
      id: '',
    },
    plan: {
      label: 'Plan',
      value: '',
      id: '',
    },
    equipoSerie: {
      label: 'Serie Equipo',
      value: '',
      id: '',
    },
    simSerie: {
      label: 'Serie Sim',
      value: '',
      id: '',
    },
  };

  constructor() {
    super();
    this.columnDefs = [
      {
        minWidth: 70,
        width: 75,
        checkboxSelection: true,
      },
      {
        headerName: 'SIM Número',
        field: 'simserienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Prefijo',
        field: 'simprefijo',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Móvil',
        field: 'simmovil',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Serie Equipo',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeqname',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Ubicación',
        field: 'tipoubicaname',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Telco',
        field: 'telconame',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
      },
      {
        headerName: 'Plan',
        field: 'telcoplanname',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
      },
      {
        headerName: 'Estado',
        field: 'configvalor',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Apn',
        field: 'simapn',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
      },
      {
        headerName: 'Tamaño',
        field: 'simtamanio',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: false,
        width: 200,
        minWidth: 200,
      },

      {
        headerName: 'Fecha Provisión',
        field: 'simprovision_fecha',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        valueFormatter: this.dateFormatter,
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: this.cant_regs_pag, //Solución Paginación
      cacheBlockSize: this.cant_regs_pag, //Solución Paginación
      paginationAutoPageSize: false,
      columnDefs: this.columnDefs,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'multiple',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },

      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  moduloModalCallback(val: boolean) {
    this.showModalEdit = val;
  }
}
